import { useEffect, useState } from "react";
import { apiCallSPPost, apiExportToExcel } from "src/_apiConfig/apiCall";
import Auth from "src/auth";
import {
  CommonSearch,
  SCDate,
  SCSelect,
  updateSearchStatus,
} from "src/views/common/CommonSearch";
import CommonList from "src/views/common/CommonList";

const PBSMSIncomeTaxConsessionRequestReport = () => {
  const { authenticated } = Auth();
  const [usersData, setUsersData] = useState(); // List Data Set
  const [pageCount, setPageCount] = useState(0); // List Data pagging manage
  const [loading, setloading] = useState(false); // page loading
  const [pageLimit, setpageLimit] = useState(0); // pageing index manage
  const [itemPerPage, setItemPerPage] = useState(10); // Record Show Each Page
  const [disabledprev, setdisabledprev] = useState(false); //Pagging Prev. Button disabled manage
  const [disablednext, setdisablednext] = useState(false); //Pagging Next Button disabled manage
  const [isSearch, setIsSearch] = useState(false); // Search Button Effect Manage
  const [isClear, setIsClear] = useState(false); // Clear Button Effect Manage
  const [isExporting, setIsExporting] = useState(false); //Export To Excel Loader Manage

  const SearchFilterModel = {
    collectionSeason:  new Date().getFullYear().toString(),
    tenderNo: "",
    lotNo: "",
    circleId: 0,
    disctrictId: 0,
    date: "",
    requestType: 0,
    requestStatus: 0,
    requestStartDate: "",
    requestEndDate: "",
  };
  // Search Model
  const [search, setSearch] = useState(SearchFilterModel);

  // Page  API URL manage
  const ReportListUrl = `Report/PBSMS/Income_Tax_Concession_Request`;
  const ReportListCountUrl = `Report/PBSMS/Income_Tax_Concession_Request/count`;
  const ReportListExcelUrl = `Report/PBSMS/Income_Tax_Concession_Request/ExportToExcel`;
  const ReportListExcelFileName = "PBSMSIncomeTaxConcessionRequestReport.xls";

  // api data manage
  const getdata = (setPageLimits = "", setItemPerPages = "") => {
    const request_type_SlotsId =
      search.requestType === "-2" || search.requestType === "-6"
        ? search.requestType
        : 0;
    const request_type_PaymentComplete =
      search.requestType > 0 ? search.requestType : 0;
    const data = JSON.stringify({
      start: setPageLimits === "" ? pageLimit : setPageLimits,
      length: setItemPerPages === "" ? itemPerPage : setItemPerPages,
      collection_season: Number(search.collectionSeason),
      tenderNo: search.tenderNo.trim(),
      circle_id: Number(search.circleId),
      district_id: Number(search.disctrictId),
      lot_no: search.lotNo.trim(),
      request_type_SlotsId: Number(request_type_SlotsId),
      request_type_PaymentComplete: Number(request_type_PaymentComplete),
      request_status: Number(search.requestStatus),
      request_start_date: search.requestStartDate,
      request_end_date: search.requestEndDate,
      date: search.date,
    });
    console.log("getdata", data);
    return data;
  };

  useEffect(() => {
    setloading(true);
    reset();
    getReportCount(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated]);

  useEffect(() => {
    if (isSearch === false) {
      getReportList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated, pageLimit]);

  useEffect(() => {
    if (isSearch) {
      getReportList();
      getReportCount();
      setIsClear(false);
      setIsSearch(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSearch, itemPerPage]);

  // pagging Disabled  manage
  const paggingDisabled = (isNext = true, isPrev = true) => {
    setdisablednext(isNext);
    setdisabledprev(isPrev);
  };
  // pagging Disabled Manage
  const paggingManage = (totalRecord, isRecordGet = true) => {
    setPageCount(parseInt(totalRecord) || 0);
    paggingDisabled(
      pageLimit >= parseInt(totalRecord) - parseInt(itemPerPage),
      pageLimit === 0
    );
  };

  // get Report List
  const getReportList = async () => {
    if (authenticated) {
      setloading(true);
      paggingDisabled();
      setUsersData();

      await apiCallSPPost(ReportListUrl, getdata(), [])
        .then((res) => {
          if (res.success) {
            setUsersData(res.data);

            if (isSearch === false && pageLimit >= 0 && pageCount > 0) {
              paggingManage(pageCount);
            }
          } else setUsersData();
        })
        .finally(() => {
          setloading(false);
        });
    }
  };

  // get Report List Count
  const getReportCount = async () => {
    if (authenticated) {
      await apiCallSPPost(ReportListCountUrl, getdata(0, 0), 0).then((res) => {
        if (res.success) paggingManage(parseInt(res.totalRecord) || 0);
        else paggingManage(0, false);
      });
    }
  };
  // get Report List ExportToExcel
  const ExportToExcel = async () => {
    setIsExporting(true);
    try {
      await apiExportToExcel(
        pageCount,
        ReportListExcelUrl,
        getdata(0, 0),
        ReportListExcelFileName
      ).finally(() => {
        setIsExporting(false);
      });
    } catch (error) {
      // Handle any errors that might occur during the export process
      console.error("Error exporting to Excel:", error);
      setIsExporting(false); // Reset isExporting state if an error occurs
    }
  };

  const reset = () => {
    setpageLimit(0);
  };

  // Search Model Value Update Manage
  const updateSearch = (e, name = "", value = "") => {
    console.log("updateSearch e:", e);
    console.log("updateSearch ddd : ", name, value);
    updateSearchStatus(setSearch, search, e, name, value);
  };
  // Pagging Prev. Button Click Event
  const prevButton = () => {
    let pageLimitCheck = pageLimit - parseInt(itemPerPage);
    if (pageLimitCheck < 0) {
      pageLimitCheck = 0;
    }
    setpageLimit(pageLimitCheck);
  };
  // Pagging Next Button Click Event
  const nextButton = () => {
    let pageLimitCheck = pageLimit + parseInt(itemPerPage);
    if (pageLimitCheck >= parseInt(pageCount)) {
      pageLimitCheck = parseInt(pageCount);
      setdisablednext(true);
    }
    setpageLimit(pageLimitCheck);
  };
  // item per page  onChanage Event
  const onChangePage = (ev) => {
    ev.preventDefault();
    setpageLimit(0);
    setItemPerPage(ev.target.value);
    setIsSearch(true);
  };

  // Search Button Click Event
  const searchButton = (ev) => {
    ev.preventDefault();
    reset();
    setIsSearch(true);
  };

  const clearSearch = (ev) => {
    ev.preventDefault();
    reset();
    setIsClear(true);
    setIsSearch(true);
    setSearch({ ...search, ...SearchFilterModel });
    setUsersData();
  };
  const requestTypeList = [
    { value: "25", label: "First Installment" },

    { value: "50", label: "Second Installment" },
    { value: "75", label: "Third Installment" },
    { value: "100", label: "Fourth Installment" },
    { value: "-2", label: "Full Payment" },
    { value: "-6", label: "Godown Quantity Diff Amount" },
  ];
  const requestStatusList = [
    { value: "1", label: "Pending" },
    { value: "2", label: "Approved" },
    { value: "3", label: "Rejected" },
  ];
  const SearchExtraControl = (
    <>
      <SCSelect
        labelname="Request Type"
        name="requestType"
        value={search.requestType}
        onChange={updateSearch}
        items={requestTypeList}
      />
      <SCSelect
        labelname="Request Status"
        name="requestStatus"
        value={search.requestStatus}
        onChange={updateSearch}
        items={requestStatusList}
      />
      <SCDate
        label="Request Start Date"
        name={"requestStartDate"}
        value={search.requestStartDate}
        onChange={updateSearch}
        maxDate={search.requestEndDate}
      />
      <SCDate
        label="Request End Date"
        name={"requestEndDate"}
        value={search.requestEndDate}
        onChange={updateSearch}
        minDate={search.requestStartDate}
      />

      {/* <SCInput
        label={"Lot No :"}
        name={"lotNo"}
        value={search.lotNo}
        onChange={updateSearch}
      /> */}
    </>
  );
  //Search Filter Manage ( UI also)
  const additional = (
    <CommonSearch
      isDisabledSearchClear={loading}
      isClear={isClear}
      search={search}
      updateSearch={updateSearch}
      searchButton={searchButton}
      clearSearch={clearSearch}
      itemPerPage={itemPerPage}
      onChangePage={onChangePage}
      //isEmailAddressDisplay={true}
      isLotNumberDisplay={true}
      extraControl={SearchExtraControl}
      isExportToExcelDisplay={true}
      isExporting={isExporting}
      isDisabledExport={usersData && usersData.length > 0 ? false : true}
      ExportToExcel={ExportToExcel}
    />
  );
  const fields = [
    {
      key: "srNo",
      _style: { width: "5%" },
      label: "S.N.",
    },
    // {
    //   key: "circleName",
    //   _style: { width: "7.5%" },
    //   label: "Circle",
    // },
    // {
    //   key: "districtName",
    //   _style: { width: "7.5%" },
    //   label: "District Union",
    // },
    {
      key: "tenderNo",
      _style: { width: "6.5%" },
      label: "Tender No.",
    },
    {
      key: "lotNo",
      _style: { width: "6.5%" },
      label: "Lot No.",
    },

    {
      key: "actualQuantity",
      _style: { width: "7.5%" },
      label: "Actual Quantity (Per STD Bags)",
    },
    {
      key: "saleRate",
      _style: { width: "7.5%" },
      label: "Sale Rate",
    },
    {
      key: "saleValue",
      _style: { width: "7.5%" },
      label: "Sale Value",
    },
      {
      key: "bidderName",
      _style: { width: "15%" },
      label: "Bidder Name",
    },
    {
      key: "companyName",
      _style: { width: "15%" },
      label: "Company Name",
    },

    {
      key: "incomeTaxConcessionRequestDate",
      _style: { width: "7.5%" },
      label: "Request Date",
    },
    {
      key: "amount",
      _style: { width: "5%" },
      label: "Payment Amount",
    },
    {
      key: "incomeTaxConsessionPercentage",
      _style: { width: "5%" },
      label: "Income Tax Concession Percentage",
    },

    {
      key: "incomeTaxAmount",
      _style: { width: "7.5%" },
      label: "Income Tax Amount",
    },

    {
      key: "requestTypeName",
      _style: { width: "7.5%" },
      label: "Request Type",
    },
    {
      key: "requestStatus",
      _style: { width: "5%" },
      label: "Request Status",
    },

    {
      key: "incomeTaxConsessionApprovalDate",
      _style: { width: "20%" },
      label: "Approval Date",
    },
  ];
  return (
    <CommonList
      items={usersData}
      fields={fields}
      listName="Income Tax Concession Request Report"
      loading={loading}
      additional={additional}
      prev={prevButton}
      next={nextButton}
      disabledprev={disabledprev}
      disablednext={disablednext}
      id="userid"
    />
  );
};

export default PBSMSIncomeTaxConsessionRequestReport;
